import PayoutRequestForm from 'modules/Forms/Referral/PayoutRequestForm'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const ReferralPayoutCreate = () => {
  const history = useHistory()
  const pathGen = useGeneratePathI18n()

  return (
    <PayoutRequestForm
      onClose={() => history.push(pathGen(ROUTES.REFERRALS))}
    />
  )
}

export default ReferralPayoutCreate
